export const categories = [
    "Entertainment",
    "Education",
    "Gaming",
    "Music",
    "News & Politics",
    "Sports",
    "Technology",
    "Science",
    "Health & Fitness",
    "Food & Cooking",
    "Travel & Adventure",
    "Vlogs & Lifestyle",
    "Movies & TV",
    "Comedy",
    "DIY & Crafts",
    "Business & Finance",
    "Motivational & Self-Improvement",
    "History & Documentaries",
    "Automobiles & Vehicles",
    "Art & Animation"
  ];
  